/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Play_By_PlayInputs */

const th_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายงานสด`)
};

const en_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play-by-play`)
};

const ja_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実況`)
};

const zh_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比赛进程`)
};

const es_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugada a jugada`)
};

const pt_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance a lance`)
};

const id_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalannya pertandingan`)
};

const fr_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action par action`)
};

const tl_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play-by-play`)
};

const vi_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diễn biến trận`)
};

const ko_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기 진행`)
};

const de_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielverlauf`)
};

const ru_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ход матча`)
};

const tr_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maç akışı`)
};

const it_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronaca`)
};

const pl_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przebieg meczu`)
};

const uk_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хід матчу`)
};

const hi_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैच का क्रम`)
};

const ar_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجريات المباراة`)
};

const ms_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalannya perlawanan`)
};

const bn_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলার বিবরণ`)
};

const zh_tw2_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比賽過程`)
};

const zh_hk2_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比賽過程`)
};

const ur_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میچ کی روداد`)
};

const fa_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روند بازی`)
};

const sw_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwenendo wa mchezo`)
};

const nl_play_by_play = /** @type {(inputs: Play_By_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijdverloop`)
};

/**
* | output |
* | --- |
* | "Play-by-play" |
*
* @param {Play_By_PlayInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const play_by_play = /** @type {((inputs?: Play_By_PlayInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Play_By_PlayInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_play_by_play(inputs)
	if (locale === "ja") return ja_play_by_play(inputs)
	if (locale === "zh") return zh_play_by_play(inputs)
	if (locale === "es") return es_play_by_play(inputs)
	if (locale === "pt") return pt_play_by_play(inputs)
	if (locale === "id") return id_play_by_play(inputs)
	if (locale === "fr") return fr_play_by_play(inputs)
	if (locale === "tl") return tl_play_by_play(inputs)
	if (locale === "vi") return vi_play_by_play(inputs)
	if (locale === "ko") return ko_play_by_play(inputs)
	if (locale === "de") return de_play_by_play(inputs)
	if (locale === "ru") return ru_play_by_play(inputs)
	if (locale === "tr") return tr_play_by_play(inputs)
	if (locale === "it") return it_play_by_play(inputs)
	if (locale === "pl") return pl_play_by_play(inputs)
	if (locale === "uk") return uk_play_by_play(inputs)
	if (locale === "hi") return hi_play_by_play(inputs)
	if (locale === "ar") return ar_play_by_play(inputs)
	if (locale === "ms") return ms_play_by_play(inputs)
	if (locale === "bn") return bn_play_by_play(inputs)
	if (locale === "zh-TW") return zh_tw2_play_by_play(inputs)
	if (locale === "zh-HK") return zh_hk2_play_by_play(inputs)
	if (locale === "ur") return ur_play_by_play(inputs)
	if (locale === "fa") return fa_play_by_play(inputs)
	if (locale === "sw") return sw_play_by_play(inputs)
	if (locale === "nl") return nl_play_by_play(inputs)
	return en_play_by_play(inputs)
});